import * as yup from 'yup';
import {
  MAX_CURRENT_EDUCATIONS,
  MAX_CURRENT_WORKS,
  minQtyTopSkills,
  validationMessages
} from '../../../../utils/constants';
import { isValidDate } from '../../../../utils/helpers';

/* TODO It is necessary to move all this file to utils, because the functions
    are used in AddEditFormModal, AddEditCVRecord AND ALSO in CVBaseItem! */

const getBlocksSettings = (block, initData, t) =>
  ({
    works: {
      windowTitle: t('dashboard.modal.workhistory'),
      zeroState: {
        title: '',
        company: '',
        startdate: '',
        enddate: '',
        description: '',
        id: initData?.Id,
        currentlyWorkThere: false,
        originalValue: false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentWorkQty: initData?.currentWorkQty || 0
      },
      initialState: {
        title: initData?.Title,
        company: initData?.CompanyName,
        startdate: isValidDate(new Date(initData?.StartDate)) ? new Date(initData?.StartDate) : '',
        enddate: initData?.EndDate && initData?.EndDate !== 'Present' ? new Date(initData?.EndDate) : new Date(),
        description: initData?.Description,
        id: initData?.Id,
        currentlyWorkThere: initData?.CurrentlyWorkThere || false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentWorkQty: initData?.currentWorkQty || 0,
        originalValue: initData?.originalValue
      },
      validationSchema: yup.object({
        title: yup.string('Enter title').required(validationMessages(t).WORK_REQ_TITLE),
        company: yup.string('Enter Company Name').required(validationMessages(t).WORK_REQ_COMPANY),
        startdate: yup
          .date()
          .typeError('Wrong date format')
          .required(validationMessages(t).DATE_REQ_START_DATE)
          .test(
            'later-than-enddate',
            validationMessages(t).DATE_START_AFTER_END,
            (value, context) => new Date(value) <= new Date(context.parent.enddate)
          ),
        enddate: yup
          .date()
          .typeError('Wrong date format')
          .required(validationMessages(t).DATE_REQ_END_DATE)
          .test(
            'earlier-than-startdate',
            validationMessages(t).DATE_END_BEFORE_START,
            (value, context) => new Date(value) >= new Date(context.parent.startdate)
          ),
        description: yup.string('Enter description').required(validationMessages(t).WORK_REQ_DESCRIPTION),
        currentlyWorkThere: yup
          .bool('Boolean required')
          .test('no-more-than-2-current', validationMessages(t).CURRENT_WORK_MAX, (value, context) => {
            return !!(
              !context.parent.withCurrentlyCheckBox ||
              !value ||
              (context.parent.withCurrentlyCheckBox &&
                value &&
                context.parent.currentWorkQty <= MAX_CURRENT_WORKS &&
                context.parent.originalValue) ||
              (context.parent.withCurrentlyCheckBox &&
                value &&
                context.parent.currentWorkQty < MAX_CURRENT_WORKS &&
                !context.parent.originalValue)
            );
          })
      })
    },
    educations: {
      windowTitle: t('dashboard.modal.education'),
      zeroState: {
        school: '',
        degree: '',
        degreetype: 'degreetype',
        fieldofstudy: '',
        startdate: '',
        enddate: '',
        currentlyStudyHere: false,
        originalValue: false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentEducationsQty: initData?.currentEducationsQty || 0
      },
      initialState: {
        school: initData?.UniversityName,
        degree: initData?.Degree,
        degreetype: initData?.DegreeType,
        fieldofstudy: initData?.FieldOfStudy,
        startdate: isValidDate(new Date(initData?.StartDate)) ? new Date(initData?.StartDate) : '',
        enddate: initData?.EndDate ? new Date(initData?.EndDate) : new Date(),
        id: initData?.Id,
        currentlyStudyHere: initData?.CurrentlyStudyHere || false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentEducationsQty: initData?.currentEducationsQty || 0,
        originalValue: initData?.originalValue
      },
      validationSchema: yup.object({
        school: yup.string('Enter School Name').required(validationMessages(t).EDUCATION_REQ_SCHOOL),
        degree: yup.string('Enter Degree').nullable().required(validationMessages(t).EDUCATION_REQ_DEGREE),
        fieldofstudy: yup.string('Enter Field of Study').required(validationMessages(t).EDUCATION_REQ_FOS),
        startdate: yup
          .date()
          .typeError('Wrong date format')
          .required(validationMessages(t).DATE_REQ_START_DATE)
          .test(
            'later-than-enddate',
            validationMessages(t).DATE_START_AFTER_END,
            (value, context) => new Date(value) <= new Date(context.parent.enddate)
          ),
        enddate: yup
          .date()
          .typeError('Wrong date format')
          .required(validationMessages(t).DATE_REQ_END_DATE)
          .test(
            'earlier-than-startdate',
            validationMessages(t).DATE_END_BEFORE_START,
            (value, context) => new Date(value) >= new Date(context.parent.startdate)
          ),
        currentlyStudyHere: yup
          .bool('Boolean required')
          .test('no-more-than-2-current', validationMessages(t).CURRENT_EDUCATION_MAX, (value, context) => {
            return !!(
              !context.parent.withCurrentlyCheckBox ||
              !value ||
              (context.parent.withCurrentlyCheckBox &&
                value &&
                context.parent.currentEducationsQty <= MAX_CURRENT_EDUCATIONS &&
                context.parent.originalValue) ||
              (context.parent.withCurrentlyCheckBox &&
                value &&
                context.parent.currentEducationsQty < MAX_CURRENT_EDUCATIONS &&
                !context.parent.originalValue)
            );
          })
      })
    },
    trainings: {
      windowTitle: t('dashboard.modal.training'),
      zeroState: {
        type: '',
        certId: '',
        valid: ''
      },
      initialState: {
        type: initData?.CertificationType,
        certId: initData?.CertificationId,
        valid: initData?.ValidUntil ? new Date(initData?.ValidUntil) : '',
        id: initData?.Id
      },
      validationSchema: yup.object({
        type: yup.string('Enter Type').required(validationMessages(t).TRAINING_REQ_TYPE)
      })
    },
    skills: {
      windowTitle: t('dashboard.modal.skills'),
      zeroState: {
        skills: []
      },
      initialState: {
        skills: initData
      },
      validationSchema: yup.object({
        skills: yup.array().test((value) => {
          const qtyTopSkills = value.filter((skill) => skill.TopSkill).length;
          return qtyTopSkills >= minQtyTopSkills;
        })
      })
    },
    industries: {
      windowTitle: t('dashboard.modal.industries'),
      zeroState: {
        industries: []
      },
      initialState: {
        industries: initData
      },
      validationSchema: yup.object({
        industries: yup.array().test((value) => value.length)
      })
    },
    functions: {
      windowTitle: t('dashboard.modal.functions'),
      zeroState: {
        functions: []
      },
      initialState: {
        functions: initData
      },
      validationSchema: yup.object({
        functions: yup.array().test((value) => value.length)
      })
    }
  }[block]);

const getInitialValues = (editeMode, initData, block, t) =>
  editeMode ? getBlocksSettings(block, initData, t)?.initialState : getBlocksSettings(block, initData, t)?.zeroState;

const getValidationSchema = (block, initData, t) => getBlocksSettings(block, initData, t)?.validationSchema;

export { getBlocksSettings, getInitialValues, getValidationSchema };
